export function validateForm(form) {
  if (form.symbol === '')
    return { result: false, reason: 'Please enter a symbol.' };
  if (form.goLong === false && form.goShort === false)
    return { result: false, reason: 'Please select a direction.' };
  if (form.setup === 'default')
    return { result: false, reason: 'Please select a setup.' };
  if (
    form.setup !== 'CANDLE_PATTERN' &&
    form.restartSystemOncePositionHasFlattened &&
    !form.restartSettings.deactivateOnRestart
  )
    return {
      result: false,
      reason:
        'Please select Deactivate on Restart to avoid trigger loop.',
    };
  if (form.watchlistName === '' || form.watchlistName === 'default')
    return { result: false, reason: 'Please select a watchlist.' };
  const setupValidationResult = form.setupDetails[form.setup].validate(form);
  if (setupValidationResult[0] === false)
    return { result: false, reason: setupValidationResult[1] };
  for (const filter of Object.keys(form.setupFilters)) {
    const validationResult = form.setupFilters[filter].validate(form);
    if (!validationResult[0])
      return { result: false, reason: validationResult[1] };
  }
  return { result: true, reason: 'Alert added.' };
}
